<template>
    <div class="py-4 container-fluid">
        <div class=" row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header pb-0">
                        <h6>Historial de pagos</h6>
                        <h6>Operario: {{ userData.name }} </h6>
                        <!-- Columna de búsqueda -->
                        <div class="row">
                            <div class="col-md-6 mb-3">
                                <label for="searchQuery" class="mb-1">Buscar</label>
                                <input type="text" v-model="searchQuery" id="searchQuery" class="form-control"
                                    placeholder="Buscar observación..." @input="fetchData(null)" />
                            </div>
                        </div>
                    </div>

                    <div class="card-body px-0 pt-0 pb-2">
                        <div class="table-responsive p-0">
                            <table class="table align-items-center mb-0">
                                <thead>
                                    <tr>
                                        <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                                            #</th>
                                        <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                                            Observación</th>
                                        <th
                                            class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                                            Total pagado</th>
                                        <th
                                            class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                                            Fecha</th>
                                        <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Opciones</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr v-if="loading">
                                        <td colspan="5" class="text-center py-4">
                                            <i class="fas fa-spinner fa-spin fa-2x text-primary"></i>
                                            <p class="mt-2 text-sm text-secondary">Cargando datos...</p>
                                        </td>
                                    </tr>
                                    <template v-else>
                                        <tr v-for="value in data" :key="value.id">
                                            <td class="align-middle text-sm">
                                                <h6 class="d-flex px-2 py-1 mb-0 text-sm">{{ value.id }}</h6>
                                            </td>
                                            <td class="align-middle text-sm">
                                                <h6 class="d-flex px-2 py-1 mb-0 text-sm">{{ value.observation }}</h6>
                                            </td>
                                            <td class="align-middle text-center text-sm">
                                                <h6 class="mb-0 text-sm">{{
                                                    parseFloat(value.total ?? 0).toLocaleString('es-ES', {
                                                        minimumFractionDigits: 2, maximumFractionDigits: 2
                                                    }) }}</h6>
                                            </td>
                                            <td class="align-middle text-center text-sm">
                                                <h6 class="mb-0 text-sm">{{ isValidDate(value.created_at) ? new
                                                    Date(value.created_at).toLocaleDateString('es-ES') : 'Sin asignar' }}
                                                </h6>
                                            </td>
                                            <td class="align-middle text-center text-sm">
                                                <a @click="getPaid(value.id)" class="text-secondary font-weight-bold text-xs cursor-pointer"
                                                    style="margin-left: 15px;" data-toggle="tooltip" data-original-title="Imprimir recibo">
                                                    <i class="fas fa-print"></i>
                                                </a>
                                                <a @click="deletePayment(value.id)" class="text-secondary font-weight-bold text-xs cursor-pointer"
                                                    style="margin-left: 15px;" data-toggle="tooltip" data-original-title="Eliminar pago">
                                                    <i class="fa fa-trash"></i>
                                                </a>
                                            </td>
                                        </tr>

                                        <tr v-if="data.length === 0">
                                            <td colspan="5" class="text-center text-xxs">No hay registros disponibles</td>
                                        </tr>
                                    </template>
                                </tbody>
                            </table>

                            <div class="pagination p-3">
                                <!-- Recorremos los links para generar los botones -->
                                <a v-for="link in links" :key="link.label" class="page-item cursor-pointer"
                                    @click="fetchData(link.url)" :disabled="!link.url || link.active"
                                    :class="{ 'active': link.label === currentPage.toString() }">
                                    {{ link.label }}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import { mapGetters } from 'vuex';
import { useRoute } from "vue-router";
import Swal from 'sweetalert2';

export default {
    name: 'ProjectsList',
    props: ['userId'],
    data() {
        return {
            searchQuery: '',
            userData: {},
        };
    },
    computed: {
        ...mapGetters('productionPayments', ['allData', 'currentPage', 'lastPage', 'pagination', 'links', 'loading']), // Mapea el getter allUsers
        currentPage() {
            return this.$store.state.productionPayments.currentPage; // Obtiene la pagina actual
        },
        lastPage() {
            return this.$store.state.productionPayments.lastPage; // Obtiene la última página
        },
        data() {
            return this.allData; // Retorna los usuarios desde el store
        },
        links() {
            return this.$store.getters['productionPayments/links']; // Retorna los links
        },
    },
    methods: {
        async fetchData(pageUrl = null) {
            const route = useRoute();
            this.userData = route.params;

            
            const params = {
                user_id: this.userData.id,
                page: pageUrl ? new window.URL(pageUrl).searchParams.get("page") || 1 : 1
            };
            
            // Agregar búsqueda si existe
            if (this.searchQuery && this.searchQuery.trim()) {
                params.search = this.searchQuery.trim();
            }
            
            await this.$store.dispatch('productionPayments/fetchData', params);
        },
        isValidDate(date) {
            if (!date) {
                return false;
            }
            const parsedDate = new Date(date);
            return !isNaN(parsedDate.getTime());
        },
         async getPaid(id) {

            // Generar directamente el PDF del recibo de pago
            this.generateDoc({ id: id });
        
        },
        async generateDoc(payment) {
            try {
                // Obtener el ID del pago
                const paymentId = payment.id || payment.data?.id;
                if (!paymentId) {
                    console.error("No se pudo obtener el ID del pago");
                    return;
                }
                
                // Generar el PDF
                const response = await this.$store.dispatch("productionPayments/getPdf", paymentId);
                
                // Crear una URL del archivo recibido
                const url = window.URL.createObjectURL(new Blob([response.data]));
        
                // Crear un enlace para descargar el archivo
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", `Recibo_Pago_${paymentId}.pdf`); // Nombre del archivo
                document.body.appendChild(link);
                link.click();
        
                // Limpiar la URL creada
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
                
            } catch (error) {
                console.error("Error al generar el PDF:", error);
                await Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: error.response?.data?.message || 'Error al generar el PDF del recibo de pago',
                });
            }
        },
        async deletePayment(id) {
            try {
                const result = await Swal.fire({
                    title: '¿Estás seguro?',
                    text: 'Esta acción no se puede deshacer. Se eliminará el registro de pago.',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#d33',
                    cancelButtonColor: '#3085d6',
                    confirmButtonText: 'Sí, eliminar!',
                    cancelButtonText: 'Cancelar'
                });

                if (result.isConfirmed) {
                    const response = await this.$store.dispatch("productionPayments/delete", id);
                    if (response && response.status >= 200 && response.status < 300) {
                        this.fetchData();
                        await Swal.fire(
                            'Eliminado!',
                            'El pago se ha eliminado correctamente.',
                            'success'
                        );
                    } else {
                        throw new Error(response.data?.message || 'Error al eliminar el pago');
                    }
                }
            } catch (error) {
                console.error("Error al eliminar el pago:", error);
                await Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: error.response?.data?.message || error.message || 'Error al eliminar el pago',
                });
            }
        },
    },
    mounted() {
        this.fetchData(); // Llama a fetchUsers cuando el componente se monta
    },
};
</script>

<style scoped>
.pagination {
    display: flex;
    justify-content: center;
    margin-top: 20px;
}

.page-item {
    margin: 0 5px;
}

.active {
    font-weight: bold;
    /* Estilo para la página activa */
}
</style>